import { Controller } from "@hotwired/stimulus"

// Navigate to the URL carried in the selected <option> value. Backs the mobile
// status-filter <select> so it behaves like the desktop tab links (each option
// value is a tab URL). Uses a Turbo advance visit when available so it slots
// into the same history behavior as the in-frame tab links.
export default class extends Controller {
  go(event) {
    const url = event.target.value
    if (!url) return

    if (window.Turbo) {
      window.Turbo.visit(url, { action: "advance" })
    } else {
      window.location.assign(url)
    }
  }
}
